<template>
  <div>
    <div class="pricing-table">
      <div class="pricing-table__column">
        <div class="popular-tag"></div>
        <div class="pricing-table__header"></div>
        <div class="pricing-table__description">
          <h2>{{ resource["pricingFeaturesTitle"] }}</h2>
          <p v-if="type === 'yearly'">{{ resource["pricingFeaturesDesc"] }}</p>
        </div>
        <div
          v-for="(feature, featureIndex) in featuresData"
          :key="featureIndex"
          :class="`pricing-table__feature ${
            feature.disabled ? 'pricing-table__feature--disabled' : ''
          }`"
        >
          {{ feature.name }}
          <i
            :id="`feature-tooltip-${featureIndex}-${type}`"
            class="icon-info ml-1"
            v-if="feature.tooltip"
            style="color: #878787; font-size: 18px"
          />
          <b-tooltip
            :target="`feature-tooltip-${featureIndex}-${type}`"
            triggers="hover"
            placement="right"
            :delay="{ show: 250, hide: 200 }"
            custom-class="feature-tooltip"
          >
            {{ feature.tooltip }}
          </b-tooltip>
        </div>
      </div>
      <div :class="'pricing-table__column'">
        <div class="popular-tag"></div>
        <div class="pricing-table__header">
          <h4>{{ trialPackage.name }}</h4>
          <p class="saving-text" v-if="type === 'yearly' && paymentIsActive">
            {{ resource["pricingNoCardRequiredText"] }}
          </p>
          <p class="price" v-if="paymentIsActive">
            {{ resource[`pricing.freeText`] }}
            <span class="price-type"
              >&nbsp;/ {{ resource[`pricing.free.table`] }}</span
            >
          </p>

          <button
            @click="
              loading || !trialPackage.enabled
                ? {}
                : paymentServiceHandler(trialPackage)
            "
            type="button"
            :class="`w-100 gap-1 border-button ${
              loading || !trialPackage.enabled ? 'disabled-btn' : ''
            }`"
            :id="`package-${trialPackage.packageId}-free-${type}`"
          >
            {{
              paymentIsActive
                ? resource["pricing.FreePlanButton"]
                : resource["pricing.contactUsButton"]
            }}
          </button>
          <b-tooltip
            v-if="(!trialPackage.enabled || !isAuth) && paymentIsActive"
            :target="`package-${trialPackage.packageId}-free-${type}`"
            triggers="hover"
            placement="bottom"
            :delay="{ show: 250, hide: 200 }"
            custom-class="feature-tooltip"
          >
            {{
              !isAuth
                ? resource["pricing.LogoutPayNowTooltipText"]
                : currentPackage.trialPackageIsUsed
                ? resource["freePlanAlreadyUsed"]
                : resource["packageAnotherPlan"]
                    .replace("{name}", currentPackage.activeMainPackage)
                    .replace(
                      "{type}",
                      resource[
                        `pricing.${currentPackage.activeMainPackageInterval}.table`
                      ]
                    )
            }}
          </b-tooltip>
        </div>
        <div class="pricing-table__description">&nbsp;</div>
        <div
          v-for="(feature, itemFeatureIndex) in trialPackage.features"
          :key="itemFeatureIndex"
          class="pricing-table__feature justify-content-center"
        >
          <i
            class="icon-tick-rounded"
            v-if="feature.value === 'true'"
            style="color: #49ca77; font-size: 24px"
          />
          <i
            class="icon-close-rounded"
            v-else-if="feature.value === 'false'"
            style="color: #c3c3c3; font-size: 24px"
          />
          <template
            v-else-if="feature.value !== null && feature.value !== undefined"
          >
            {{ feature.value }}
          </template>
        </div>
      </div>
      <div
        v-for="(item, index) in items"
        :key="index"
        :class="[
          'pricing-table__column',
          item.isPopular ? 'pricing-table__column--popular' : '',
        ]"
      >
        <div class="popular-tag">
          <template v-if="item.isPopular">
            <!-- <i class="icon-awesome" /> -->
            {{ resource["pricingPopularText"] }}
          </template>
        </div>
        <div class="pricing-table__header">
          <h4>{{ item.name }}</h4>
          <p class="saving-text" v-if="type === 'yearly' && paymentIsActive">
            {{ resource["pricingSavingText"] }} €{{
              (item.unitAmount / 10) * 2
            }}
          </p>
          <p class="price" v-if="paymentIsActive">
            €{{ item.unitAmount }}
            <span class="price-type"
              >&nbsp;/ {{ resource[`pricing.${item.type}.table`] }}</span
            >
          </p>
          <button
            @click="loading || !item.enabled ? {} : paymentServiceHandler(item)"
            type="button"
            :class="`w-100 gap-1 ${
              loading || !item.enabled ? 'disabled-btn' : ''
            }`"
            :id="`package-${item.packageId}-${type}`"
          >
            {{
              paymentIsActive
                ? resource["pricing.ButtonLoggedUser"]
                : resource["pricing.contactUsButton"]
            }}
          </button>
          <b-tooltip
            v-if="(!item.enabled || !isAuth) && paymentIsActive"
            :target="`package-${item.packageId}-${type}`"
            triggers="hover"
            placement="bottom"
            :delay="{ show: 250, hide: 200 }"
            custom-class="feature-tooltip"
          >
            {{
              !isAuth
                ? resource["pricing.LogoutPayNowTooltipText"]
                : item.packageId === currentPackage?.activeMainPackageId
                ? resource["packageDisableText"]
                : resource["packageAnotherPlan"]
                    .replace("{name}", currentPackage.activeMainPackage)
                    .replace(
                      "{type}",
                      resource[
                        `pricing.${currentPackage.activeMainPackageInterval}.table`
                      ]
                    )
            }}
          </b-tooltip>
        </div>
        <div class="pricing-table__description">&nbsp;</div>
        <div
          v-for="(feature, itemFeatureIndex) in item.features"
          :key="itemFeatureIndex"
          class="pricing-table__feature justify-content-center"
        >
          <i
            class="icon-tick-rounded"
            v-if="feature.value === 'true'"
            style="color: #49ca77; font-size: 24px"
          />
          <i
            class="icon-close-rounded"
            v-else-if="feature.value === 'false'"
            style="color: #c3c3c3; font-size: 24px"
          />
          <template
            v-else-if="feature.value !== null && feature.value !== undefined"
          >
            {{ feature.value }}
          </template>
        </div>
      </div>
      <!-- <ProductItem v-for="(item, index) in pricingData.packages" :key="index" :item="item"
          @paymentLoading="loading = $event" :paymentLoading="loading" :category="title" :pricingType="pricingType" :paymentIsActive="paymentIsActive" /> -->
    </div>
  </div>
</template>

<script>
import AccountService from '@/services/account';
import hrvenueService from '../../../services/hrvenue.service';
import { showNotification } from '../../../static/helpers';
// import ProductItem from '../productItem';

export default {
  name: 'PricingTabItem',
  components: {
    // ProductItem,
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    trialPackage: {
      type: Object,
      required: true,
      default: () => {},
    },
    paymentIsActive: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    currentPackage: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      featuresData: this.trialPackage?.features || this.items[0].features,
    };
  },

  // created() {
  //   this.featuresData = this.trialPackage?.features || this.items[0].features;
  // },

  computed: {
    isAuth() {
      return AccountService.checkAuth();
    },
  },

  methods: {
    async paymentServiceHandler(item) {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      if (this.isAuth) {
        if (!this.paymentIsActive) {
          this.$router.push({ name: 'ContactUs', params: { lang } });
          return;
        }
        this.loading = true;
        try {
          const response = await hrvenueService.paymentStart(item.packageId);
          if (response.checkoutUrl) {
            window.location.replace(response.checkoutUrl);
          } else if (response.checkoutId && response.isTrialPackage) {
            showNotification(
              this.resource['label.Success'],
              this.resource['pricing.startPayment.TrialPackage.Success'],
              'success',
            );
          }
        } catch (error) {
          this.loading = false;
        }
      } else {
        this.$router.push({ name: 'RegisterView', params: { lang } });
      }
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'package_click',
        event_parameters: {
          choose_plan: `${item.type?.toLowerCase() || this.type}/${item.name?.toLowerCase()?.replaceAll(' ', '-')}`,
        },
        page_type: 'pricing',
        site_type: 'interview',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/starter.scss";

.pricing-table {
  width: 100%;
  display: flex;
  border-radius: 12px;
  border: 1px solid #e5e5e5;
  background: #fff;
  margin-top: 24px;
  padding: 16px;

  &__column {
    display: flex;
    justify-content: flex-start;
    min-width: 150px;
    flex-direction: column;
    align-items: flex-start;
    border: 1px solid transparent;
    width: calc((100% - 335px) / 3);

    &:first-child {
      width: 335px;
    }
    .popular-tag {
      background: transparent;
    }
    &--popular {
      border-radius: 12px;
      border: 1px solid #ff8d06;

      .pricing-table__feature {
        &:last-child {
          border-bottom: 0;
        }
      }
      h4 {
        color: #ff8d06 !important;
      }
      .popular-tag {
        background: #ffe9ce;
      }
    }
  }
  &__header {
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    flex: 1;

    h4 {
      color: #333;
      text-align: center;
      font-family: Roboto;
      font-size: 18px;
      font-weight: 700;
      line-height: 24px;
      margin-bottom: 0;
    }
    .saving-text {
      color: #878787;
      text-align: center;
      font-family: Roboto;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      margin-bottom: 0;
      flex: 1;
    }
    .price-type {
      color: #878787;
      text-align: center;
      font-family: Roboto;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      margin-bottom: 0;
    }
    .price {
      color: #333;
      font-family: Roboto;
      font-size: 22px;
      font-weight: 500;
      line-height: 28px;
      margin-bottom: 0;
    }
    button {
      margin-top: 24px;
      display: flex;
      padding: 9px 16px;
      justify-content: center;
      align-items: center;
      border-radius: 44px;
      border: 0;
      background: #ff8d06;
      color: #fff;
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-weight: 700;
      line-height: 18px;

      &.disabled-btn {
        background-color: #cccccc !important;
        color: #fff;
        cursor: not-allowed;
      }
    }

    .border-button {
      background: transparent !important;
      color: #ff8d06;
      border: 1px solid #ff8d06;

      &.disabled-btn {
        background: transparent !important;
        color: #ccc !important;
        border: 1px solid #cccccc !important;
        cursor: not-allowed;
      }
    }
  }
  .popular-tag {
    display: flex;
    padding: 8px 0px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    min-height: 36px;

    color: #ff8d06;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    line-height: 140%;
  }
  &__description {
    width: 100%;
    padding: 8px;

    h2 {
      color: #333;
      font-family: Roboto;
      font-size: 18px;
      font-weight: 700;
      line-height: 24px;
      margin-bottom: 2px;
    }
    p {
      color: #878787;
      font-family: Roboto;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      margin-bottom: 0;
    }
  }
  &__feature {
    width: 100%;
    display: flex;
    height: 48px;
    padding: 8px;
    align-items: center;
    align-self: stretch;
    border-bottom: 1px solid #e5e5e5;

    color: #333;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;

    &--disabled {
      color: #878787;
    }
  }
}

.feature-tooltip {
  opacity: 1 !important;

  &.bs-tooltip-right {
    margin-left: 5px;
    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17" fill="none"><path d="M9 0L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 15.5L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0L9 1.5L8 2.31994L2.22618 7.77299C1.80835 8.16761 1.80835 8.83239 2.22618 9.22701L8 14.6801L9 15.5Z" fill="%23E5E5E5"/></svg>');
        width: 9px;
        height: 17px;
      }
    }
  }

  &.bs-tooltip-bottom {
    padding: 0 !important;
    top: 15px !important;

    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17" fill="none"><path d="M9 0L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 15.5L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0L9 1.5L8 2.31994L2.22618 7.77299C1.80835 8.16761 1.80835 8.83239 2.22618 9.22701L8 14.6801L9 15.5Z" fill="%23E5E5E5"/></svg>');
        width: 9px;
        height: 17px;
        transform: rotate(90deg);
        bottom: 2px;
      }
    }
  }

  ::v-deep .tooltip-inner {
    background: #fff !important;
    border-radius: 4px !important;
    padding: 12px !important;
    width: 208px !important;
    box-shadow: 0px 2px 6px 0px rgba(176, 186, 197, 0.6);

    text-align: left;
    color: #333;
    /* Typography/Small Text/1 - Regular */
    font-family: Roboto;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
}
</style>
